export const SET_DAYS = 'SET_DAYS'
export const SET_STATUS = 'SET_STATUS'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const RESET_MODULE_STATE = 'RESET_MODULE_STATE'
export const SET_REVIEW_REQUEST_STATISTICS = 'SET_REVIEW_REQUEST_STATISTICS'

export const SESSION_DAYS = 'reviewRequest/days'
export const SESSION_STATUS = 'reviewRequest/status'
export const SESSION_PAGE_SIZE = 'reviewRequest/pageSize'
export const SESSION_SEARCH_TERM = 'reviewRequest/searchTerm'



// WEBPACK FOOTER //
// ./src/store/modules/review-requests/types.js